import { render } from "./ChallengeLinkRequests.vue?vue&type=template&id=638f6a7c&scoped=true"
import script from "./ChallengeLinkRequests.vue?vue&type=script&lang=js"
export * from "./ChallengeLinkRequests.vue?vue&type=script&lang=js"

import "@/css/components/challenge-link-requests.css?vue&type=style&index=0&id=638f6a7c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638f6a7c"]])

export default __exports__